import { MsalProvider } from '@azure/msal-react';
import { Spinner } from '@consigli/facade';
import { AuthProvider, getSessionFromStorage } from '@consigli/oauth';
import { FC, Suspense } from 'react';
import { RouterProvider } from 'react-router';

import { FeatureFlagProvider } from '@/feature-flags';
import { ErrorBoundary, captureError } from '@/monitoring';

import { getMsalInstance } from './config/msal-config';
import { ErrorPage } from './pages/error-page';
import { router } from './router';

import 'reactjs-popup/dist/index.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-toastify/dist/ReactToastify.css';

const msalInstance = getMsalInstance();

/**
 * The boundary wraps `Suspense` rather than sitting inside it: a boundary below
 * Suspense cannot catch the error a failed lazy chunk re-throws. Without it a
 * throw in any of these providers is a white screen.
 */
export const App: FC = () => (
  <ErrorBoundary
    capture={captureError}
    fallback={(error) => (
      <ErrorPage error={error} canSendFeedback={getSessionFromStorage() != null} />
    )}
  >
    <Suspense fallback={<Spinner />}>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <FeatureFlagProvider>
            <RouterProvider router={router} />
          </FeatureFlagProvider>
        </AuthProvider>
      </MsalProvider>
    </Suspense>
  </ErrorBoundary>
);
